export default __webpack_public_path__ + "static/barfplan-blog-promo@2x-8b4c5c56ddddcaf98fae2469900c5499.webp";